/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APICarrier } from '@/models/api/carrier.model'

const resource = {
    main: 'services',
    module: 'carriers'
}

export class CarriersServices {
    public static getCarriers () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getCarriersPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getCarriersById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createCarriers (params: APICarrier) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editCarriers (params: APICarrier) {
        return service.put(`${resource.main}/${resource.module}/${params.carrierId}`, params)
    }

    public static deleteCarriers (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static restoreCarriers (id: number) {
        return service.put(`${resource.main}/${resource.module}/restore/${id}`)
    }
}
